// extracted by mini-css-extract-plugin
export default {"login":"login-box_login__z8gbt","login_link":"login-box_login_link__5Tk3z"};